<div class="mainDiv" [routerLink]="['/' + lang + '/session/signin']">
  <i class="material-icons mr-1 LoginProfileIcon">account_circle</i
  ><span>Login & Register</span>
</div>
